import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import useStyle from './style';
import Context from './../Context';
import { SyncIcon } from 'components/Icons';
import PresencasResponse from 'models/PresencasResponse';

interface Props {
  presencas?: PresencasResponse,
  className?: string;
}

export default function ({
  presencas,
  className
}: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const {atualizarPresencas, atualizandoPresencas} = useContext(Context);

  return (
    <Grid container spacing={3} className={ className || '' }>
      <Grid item xs={12} sm={12} md={3}>
        <Paper className={classes.cartao}>
          <Typography className={classes.label}>
            {t('AssembleiaAssessorRoute.infoCardLabel.participantes')}
          </Typography>
          <Typography className={classes.value}>{atualizandoPresencas ? '-' : presencas?.usuariosLogados || 0}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={12} md={3}>
        <Paper className={classes.cartao}>
          <Typography className={classes.label}>
            {t('AssembleiaAssessorRoute.infoCardLabel.colaboradoresPresentes')}
          </Typography>
          <Typography className={classes.value}>{atualizandoPresencas ? '-' : presencas?.colaboradoresPresentes || 0}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={12} md={3}>
        <Paper className={classes.cartao}>
          <Typography className={classes.label}>
            {t('AssembleiaAssessorRoute.infoCardLabel.presentes')}
          </Typography>
          <Typography className={classes.value}>{atualizandoPresencas ? '-' : presencas?.presentes || 0}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={12} md={3} container justify="flex-end" alignItems="center">
        <Button
          variant="text"
          color="primary"
          onClick={() => atualizarPresencas()}
          endIcon={<SyncIcon animated={atualizandoPresencas} />}
          disabled={atualizandoPresencas}
        >
          <Typography component="p" className={classes.syncLabel}>
            {t('AssembleiaAssessorRoute.buttonAtualizarParticipantes')}
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
}